import { Overlay } from 'trading-vue-js';

export default {
    name: 'BB',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad',
                version: '1.0.0',
                desc: 'Bollinger Bands',
                preset: {
                    name: 'BB $length $stddev',
                    side: 'onchart',
                    settings: {
                        lineWidth: 0.75,
                        borderColor: '#2cc6c9',
                        middleColor: '#2cc6c9',
                        showMid: true,
                        backColor: '#2cc6c911',
                    },
                },
            };
        },
        draw(ctx) {
            ctx.lineWidth = this.line_width;
            ctx.fillStyle = this.back_color;
            for (var i = 0; i < this.$props.data.length - 1; i++) {
                let p1 = this.mapp(this.$props.data[i]);
                let p2 = this.mapp(this.$props.data[i + 1]);
                if (!p2) continue;
                ctx.beginPath();
                ctx.moveTo(p1.x, p1.y0);
                ctx.lineTo(p2.x + 0.1, p2.y0);
                ctx.lineTo(p2.x + 0.1, p2.y2);
                ctx.lineTo(p1.x, p1.y2);
                ctx.fill();

                ctx.beginPath();
                ctx.strokeStyle = this.border_color;
                ctx.moveTo(p1.x, p1.y0);
                ctx.lineTo(p2.x, p2.y0);
                ctx.stroke();
                ctx.beginPath();
                ctx.strokeStyle = this.border_color;
                ctx.moveTo(p1.x, p1.y2);
                ctx.lineTo(p2.x, p2.y2);
                ctx.stroke();
                ctx.beginPath();
                ctx.strokeStyle = this.middle_color;
                ctx.moveTo(p1.x, p1.y1);
                ctx.lineTo(p2.x, p2.y1);
                ctx.stroke();
            }
        },
        mapp(p) {
            const layout = this.$props.layout;
            return (
                p && {
                    x: layout.t2screen(p[0]),
                    y0: layout.$2screen(p[1]),
                    y1: layout.$2screen(p[2]),
                    y2: layout.$2screen(p[3]),
                }
            );
        },
        use_for() {
            return ['BB'];
        },
        calc() {
            return {
                props: {
                    length: { def: 21, text: 'Length' },
                    stddev: { def: 2, text: 'StdDev' },
                },
                conf: { renderer: 'Channel' },
                update: `
                    let [m, h, l] = bb(close, length, stddev)
                    return [h[0], m[0], l[0]]
                `,
            };
        },
    },
    computed: {
        sett() {
            return this.$props.settings;
        },
        line_width() {
            return this.sett.lineWidth || 0.75;
        },
        border_color() {
            return this.sett.borderColor || '#2cc6c9';
        },
        middle_color() {
            return this.sett.middleColor || '#2cc6c9';
        },
        back_color() {
            return this.sett.backColor || '#2cc6c911';
        },
    },
};
